module.exports = __webpack_public_path__ + "img/рз_21.951ccb8f.png";